<template>
  <v-form ref="paymentForm" class="paymentdetails">
    <div class="text-xs-left subheading font-weight-bold ">Payment Type</div>
    <v-layout class="ml-4" column>
      <div v-if="onlyCreditCards">

      </div>
      <div v-else-if="onlyInPerson" class="text-xs-left subheading">
        {{artistName}} will collect payment next time they see you.
      </div>
      <v-radio-group
        v-else
        v-model="radioGroup"
        label="How do you want to pay for you items?"
        :rules="requiredRule"
      >
        <v-radio
          :key="1"
          :label="`In person (I will see ${artistName} soon)`"
          value="inperson"
          name="payment type"
        ></v-radio>
        <v-radio
          :key="2"
          label="Credit card"
          value="creditcard"
          name="payment type"
        ></v-radio>
      </v-radio-group>
      <div v-show="radioGroup=='creditcard' || onlyCreditCards" class="subheading">
        <div id="card-element-checkout">
          <!-- A Stripe Element will be inserted here. -->
        </div>

        <!-- Used to display form errors. -->
        <div id="card-errors-checkout" role="alert" class="error--text"></div>
        <br />
        <v-checkbox @change="useDeliveryAddressChanged" v-model="useDeliveryAddressForBillingInput" label="Billing address is same as delivery address."></v-checkbox>
        <div v-if="!useDeliveryAddressForBillingInput">
          <AddressInput ref="billingAddress" v-model="billingAddressInput" >

          </AddressInput>
        </div>
      </div>
    </v-layout>
  </v-form>
</template>

<script>
import {mapState} from 'vuex'
import config from '../../../config.js'
import AddressInput from '../../common/AddressInput'

export default {
  name: 'PaymentDetails',
  components: {
    AddressInput
  },
  data: function () {
    return {
      helpTip: false,
      inperson: false,
      radioGroup: null,
      card: null,
      stripe: null,
      useDeliveryAddressForBillingInput: true,
      billingAddressInput: {},
      requiredRule: [
        this.myRequired
      ]
    }
  },
  watch: {
    billingAddressInput: function (n) {
      this.setBillingAddress()
    },
    radioGroup: function (val) {
      this.setPaymentType()
    }
  },
  computed: {
    ...mapState({
      artistName: state => state.shopping.name,
      acceptCreditCards: state => state.shopping.public_settings.acceptCreditCards,
      acceptInPersonPayment: state => state.shopping.public_settings.acceptInPersonPayment,
      paymentType: state => state.cart.paymentType,
      useDeliveryAddressForBilling: state => state.cart.useDeliveryAddressForBilling,
      billingAddress: state => state.cart.billingAddress
    }),
    onlyCreditCards: function () {
      return this.acceptCreditCards && !this.acceptInPersonPayment
    },
    onlyInPerson: function () {
      return !this.acceptCreditCards && this.acceptInPersonPayment
    }
  },
  mounted: function () {
    this.stripe = window.Stripe(config.stripePublishableKey)
    const elements = this.stripe.elements()

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    }

    // Create an instance of the card Element.
    this.card = elements.create('card', {style: style})

    // Add an instance of the card Element into the `card-element` <div>.
    this.card.mount('#card-element-checkout')

    // Handle real-time validation errors from the card Element.
    this.card.addEventListener('change', function (event) {
      var displayError = document.getElementById('card-errors-checkout')
      if (event.error) {
        displayError.textContent = event.error.message
      } else {
        displayError.textContent = ''
      }
    })

    // Now copy in any data we have
    if (this.paymentType) {
      this.radioGroup = this.paymentType
    }
    if (this.useDeliveryAddressForBilling !== undefined) {
      this.useDeliveryAddressForBillingInput = this.useDeliveryAddressForBilling
    }
    if (this.billingAddress) {
      this.billingAddressInput = this.billingAddress
    }

    // And set the value in the cart
    this.setPaymentType()
  },
  methods: {
    useDeliveryAddressChanged: function () {
      console.log('DEL ADD CHANGE')
      this.$store.commit('cart/setUseDeliveryAddressForBilling', this.useDeliveryAddressForBillingInput)
    },
    myRequired (v) {
      if (this.onlyCreditCards || this.onlyInPerson) return true
      return !!v || 'A selection is required'
    },
    setPaymentType: function () {
      this.$store.commit('cart/setPaymentType', this.getData().type)
    },
    setBillingAddress: function () {
      this.$store.commit('cart/setBillingAddress', this.billingAddressInput)
    },
    getData: function () {
      // Returns the form data
      let theType = this.radioGroup
      if (this.onlyCreditCards) {
        theType = 'creditcard'
      } else if (this.onlyInPerson) {
        theType = 'inperson'
      }
      return {
        type: theType
      }
    },
    getStripeToken: function (tokenData) {
      // Return a Promise which has a stripe token result (or error)
      return this.stripe.createToken(this.card, tokenData)
    },
    isValid: function () {
      const formIsValid = this.$refs.paymentForm.validate()
      if (this.radioGroup === 'creditcard' && !this.useDeliveryAddressForBillingInput) {
        return formIsValid && this.$refs['billingAddress'].isValid()
      } else {
        return formIsValid
      }
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.StripeElement {
  background-color: white;
  height: 40px;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
